import React from 'react';
import NextImage from 'next/image';

import tef from 'Public/images/clearing/2025/TEF-Gold-Sticker.png';

import { TefWrapper, TefImageWrapper, TextWrapper, Heading, Citation } from './Tef.styled';

export interface Props {
    heading: string;
    citation?: string;
}

const Tef: React.FC<Props> = props => {
    const { heading, citation } = props;

    return (
        <TefWrapper>
            <TefImageWrapper>
                <NextImage src={tef} alt="Tef gold logo" fill />
            </TefImageWrapper>
            <TextWrapper>
                <Heading>{heading}</Heading>
                <Citation>{citation}</Citation>
            </TextWrapper>
        </TefWrapper>
    );
};

export default Tef;
